<div class="container-box login-failure" *ngIf="!accessDenied">

  <div class="alert valign-children-middle msg">
    <div class="alert-error" aria-label="Error.">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div>
      <h2> {{errContent}}</h2>
      <p> {{ msgContent }}</p>
      <p>
        <a (click)="redirectToHome()" href="javascript:void(0)">{{ redirectLink }}</a>
      </p>
    </div>
    <!-- <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div> -->
  </div>
</div>

<div class="container-box login-failure" *ngIf="accessDenied">
  <h2 class="valign-children-middle msg"> Access Denied</h2>
  <div class="alert valign-children-middle msg">
    <div class="alert-error" aria-label="Error.">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div>
      
      <span> Right now, there are no FANs available for you to register in the Device Management Program.</span>
      <div>
        <span>This is usually because:</span>
        <ul class="error-list">
          <li>Administrator access is required, or</li>
          <li>The FAN doesn't meet eligibility requirements.</li>
        </ul>
      </div>
      <span>
        If you believe this is incorrect, contact your company administrator or AT&T representative for help.
      </span>    
    </div>
  </div>
</div>